import { get, reduce } from 'lodash';
import { INCOME_SOURCE_OPTIONS } from 'helpers/Constants';
import moment from 'moment';
import validations from 'validations/validations';

export function getData(path) {
  return get(window, ['AppConfig', 'reg_field_vals', path]);
}

export function getZip(path) {
  return (getData(path) || '').substring(0, 5);
}

export function getIncomeSource(incomeType) {
  if (INCOME_SOURCE_OPTIONS.find((item) => item.value === incomeType)) {
    return incomeType;
  }
  return '';
}

export function getNumericData(path) {
  const data = getData(path) || '';
  return data.replace(/[^0-9]/g, '');
}

export function getPhoneNumber(phoneNumber) {
  const slicedNumber = phoneNumber
    ? phoneNumber.replace(/\D/g, '').slice(-10)
    : '';
  return slicedNumber.length === 10 ? slicedNumber : '';
}

export function getLastPayrollDate(date, payrollFrequency) {
  if (!payrollFrequency || payrollFrequency === '') {
    return '';
  }
  const lastPayrollDate = moment(date);
  const lowerBound = payrollFrequency === 'twice_per_month' ? 18 : 40;
  const minDate = moment().subtract(lowerBound, 'day');
  if (lastPayrollDate >= minDate && lastPayrollDate <= moment()) {
    return lastPayrollDate.format('MM/DD/YYYY');
  }
  return '';
}

export function getNextPayrollDate(date, payrollFrequency, lastDate) {
  if (payrollFrequency !== 'twice_per_month') {
    return '';
  }
  const nextPayrollDate = moment(date);

  const lastPayrollDate = moment(lastDate);

  const minDate =
    moment() < lastPayrollDate.clone().add(10, 'day')
      ? lastPayrollDate.clone().add(10, 'day')
      : moment();

  const maxDate = lastPayrollDate.clone().add(18, 'day');

  if (nextPayrollDate >= minDate && nextPayrollDate <= maxDate) {
    return nextPayrollDate.format('MM/DD/YYYY');
  }
  return '';
}

export function getMaritalStatus() {
  const maritalStatus = getData('registration[is_married]');
  if (maritalStatus === 'true') {
    return 'married';
  }
  if (maritalStatus === 'false') {
    return 'single';
  }
  return undefined;
}

export function getPaymentType(paymentType) {
  if (!paymentType) {
    return '';
  }
  if (paymentType === 'direct_deposit') {
    return 'directDeposit';
  }
  return 'other';
}

function convertMonthsToSelectOptions(months) {
  if (months < 1) {
    return '0';
  }
  if (months < 6) {
    return '3';
  }
  if (months < 12) {
    return '9';
  }
  if (months < 49) {
    return '24';
  }
  if (months > 48) {
    return '60';
  }
  return null;
}

// Exported for tests
export function getBankAccountAge() {
  const months =
    get(window, [
      'AppConfig',
      'reg_field_vals',
      'registration[account_length][months]'
    ]) || '';
  const years =
    get(window, [
      'AppConfig',
      'reg_field_vals',
      'registration[account_length][years]'
    ]) || '';

  const totalMonths = parseInt(months, 10) + 12 * parseInt(years, 10);
  return convertMonthsToSelectOptions(totalMonths);
}

export function getLengthOfReceivingIncome() {
  const dateOfHire =
    get(window, [
      'AppConfig',
      'reg_field_vals',
      'registration[date_of_hire]'
    ]) || '';
  const months = moment().diff(
    new Date(dateOfHire.replace(/ /g, '')),
    'months'
  );
  return convertMonthsToSelectOptions(months);
}

export function setDisabled(propsArr, store) {
  return reduce(
    propsArr,
    (acc, fieldId) => {
      const validationFunction = validations[fieldId];
      const errorObject = validationFunction(store);

      if (store[fieldId] && !errorObject[fieldId]) {
        acc[fieldId] = true;
      }
      return acc;
    },
    {}
  );
}
